import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import { toJS, observable, makeObservable, reaction } from "mobx";
import {checkbox, custom, input} from "../../../utils/linker";
import ImageDrop from "../../Helpers/ImageDrop";
import axios from "axios"
import Loading from "../../Loading";

class TenorGif extends Component {
  search_query='';
  list={
    next:null,
    fetching:false,
    inited: false,
    data:[]
  }
  constructor(props) {
    super(props);
    makeObservable(this,{
      // search_query: observable,
      list: observable,
    });
    this._unreactSearch=reaction(()=>{
      return this.props.linker.value.search;
    },(item)=>{
      this.searchGifs();
    },{ delay:300 });
  }
  componentWillUnmount() {
    this._unreactSearch();
  }

  searchGifs(next=false) {
    this.list.fetching=true;
    let pos='';
    if(next) {
      if(this.list.inited && this.list.next) {
        pos = '&pos='+this.list.next;
      }
    } else {
      pos='';
    }
    axios.get(`https://g.tenor.com/v1/search?q=${encodeURIComponent(this.props.linker.value.search)}&key=2ZKBEPWY83L4&limit=10${pos}`).then((data)=>{
      this.list.next=data.data.next;
      this.list.data=data.data.results;
      this.list.fetching=false;
      this.list.inited=true;
    });
  }
  componentDidMount() {
    if(this.props.linker.value.search) {
      this.searchGifs();
    }
    if(!this.props.linker.value.image) {
      this.props.linker.value.image = null;
    }

  }
  deleteMe(deleteState) {
    if(deleteState) {
      this.props.linker.value.delete=1;
    } else {
      delete this.props.linker.value.delete;
    }
  }
  chooseGif(item) {
    const url=`https://g.tenor.com/v1/registershare?id=${item.id}&key=2ZKBEPWY83L4&q=${encodeURIComponent(this.props.linker.value.search)}`;
    axios.get(url);
    this.props.linker.value.item=item;
  }
  renderResult() {
    if(!this.props.linker.value.search) {
      return null;
    }
    if(!this.list.inited) {
      return <Loading />
    }
    const gifs=this.list.data.map((item,index)=>{
      return (
        <img key={index} onClick={()=>{ this.chooseGif(item); }} src={item.media[0].nanogif.url} alt="" className="dib vat pointer rad4 mright2 mbottom2" />
      )
    });
    return (
      <div>
        {gifs}
        <span onClick={()=>{ this.searchGifs(true); }} className="bg-w1-op50 bg-w1-hover tad4 dib vam pointer tac ptop30" style={{width:90,height:90}}>Next →</span>
      </div>
    )
  }
  renderChoosed() {
    if(this.props.linker.value.item) {
      return (
        <img src={this.props.linker.value.item.media[0].gif.url}/>
      )
    }
  }
  render() {
    return (
      <div className="padd20 bg-w2 pr rad4 mbottom10">
        <div className="pa pa-tr mdi mdi-close sc1 fs24 lh10 pointer" onClick={()=>{ this.props.deleteMe(); }}></div>
        {this.renderChoosed()}
        <input autoFocus={true} type="text" placeholder={this.props.translateStore.t.lk.attach_gif_enter_keywords} className="big w100" {...input(this.props.linker.value,'search')} />
        {this.renderResult()}
        <div className="ptop5">
          <label>
            <input type="checkbox" value="1" {...checkbox(this.props.linker.value,"spoiler")} /><span className="vam"></span> <span className="dib vam">Есть спойлеры</span>
          </label>
        </div>
      </div>
    )
  }
}

export default inject("appStateStore","translateStore")(observer(TenorGif));